import { fetch_scada_server } from './fetch';
import { loadModules } from 'esri-loader';


const { 
    REACT_APP_BASE_URL_GIS_SERVER} = window['runConfig'];


//------------------------------USE ESRI REQUEST-----------------------------------
//-----------------------------------------------------------------------
//-----------------------------------------------------------------------

export const get4ContantParam = (token, whereClause) => {
    //with this we can get 4: 
    //+Billed Unmetered Consumption (AVERAGE READING)
    //+Unbilled Authorised Consumption
    //+Unauthorised Consumption (Illegal)
    //+Customer Metering Inaccuracies
    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/server/rest/services/KELANTAN/KELANTAN_DMA_NRW_V1/FeatureServer/3/Query`;

            const bodyFormData_get4ContantParam = new FormData();
            bodyFormData_get4ContantParam.set('f', 'json')
            bodyFormData_get4ContantParam.append('outFields', 'CODE, NAME');
            bodyFormData_get4ContantParam.append('where', '1=1');
            bodyFormData_get4ContantParam.append('token', `${token}`);

            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_get4ContantParam,
            })
        });

    return res;
}

export const getTotalLengthDMA = (token, whereClause) => {
    //we can get:
    //+Total Length of Mains

    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/server/rest/services/KELANTAN/KELANTAN_PIPELINES_V1/MapServer/2/Query`;

            const bodyFormData_getTotalLengthDMA = new FormData();
            bodyFormData_getTotalLengthDMA.set('f', 'json');
            const outStatistics = [
                {
                    "statisticType": "sum",
                    "onStatisticField": "SHAPE.STLength()/1000",
                    "outStatisticFieldName": "TotalLenghtByDMA"
                }
            ];
            bodyFormData_getTotalLengthDMA.append('outStatistics', JSON.stringify(outStatistics));
            bodyFormData_getTotalLengthDMA.append('groupByFieldsForStatistics', 'DMAID');
            bodyFormData_getTotalLengthDMA.append('outFields', 'DMAID');
            bodyFormData_getTotalLengthDMA.append('orderByFields', 'DMAID ASC');

            bodyFormData_getTotalLengthDMA.append('token', `${token}`);

            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_getTotalLengthDMA,
            })
        });

    return res;

}

export const getAveragePressurceWaterSupply = (token, objectParam) => {
    //we can get:
    //+Average Pressure
    //+Water Supply

    const config_token = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    return fetch_scada_server.post('api/nrw/GetNRWScadaInputData', objectParam, config_token)
}

export const getTotalConnection = (token, whereClause) => {
    //we can get:
    //+Total connection
    let res = loadModules(["esri/request"], { css: true })
        .then(([esriRequest]) => {

            let baseURL = `${REACT_APP_BASE_URL_GIS_SERVER}`
            let url = `${baseURL}/server/rest/services/KELANTAN/KELANTAN_CONSUMERMETER_V1/MapServer/0/Query`;

            const bodyFormData_getTotalConnection = new FormData();
            bodyFormData_getTotalConnection.set('f', 'json');
            const outStatistics = [
                {
                    "statisticType": "count",
                    "onStatisticField": "ACCOUNTID",
                    "outStatisticFieldName": "TotalConnection"
                }
            ];
            bodyFormData_getTotalConnection.append('outStatistics', JSON.stringify(outStatistics));
            bodyFormData_getTotalConnection.append('groupByFieldsForStatistics', 'DMAID');
            bodyFormData_getTotalConnection.append('outFields', 'DMAID');
            bodyFormData_getTotalConnection.append('orderByFields', 'DMAID ASC');

            bodyFormData_getTotalConnection.append('token', `${token}`);

            return esriRequest(url, {
                responseType: "json",
                body: bodyFormData_getTotalConnection,
            })
        });

    return res;
}

export const getBilledMeteredConsumptioin = (token, objectParam) => {
    //we can get:
    //+Bill Metered Consumption
    const config_token = {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }
    return fetch_scada_server.post('api/nrw/GetNRWBillingInputData', objectParam, config_token)
}

//-----------------------------------------------------------------------
//-----------------------------------------------------------------------
//-----------------------------------------------------------------------

//where = '1 = 1 and MONTH = 7 and YEAR = 2020'

